import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Panel } from 'rsuite'
import ProjectOrganizationForm from './ProjectOrganizationForm'
import ProjectOrganizationView from './ProjectOrganizationView'
import scrollToComponent from 'react-scroll-to-component'
import EditButton from '../../../components/buttons/editButton/EditButton'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import { useForm, Controller } from 'react-hook-form'
import {
  getOrganization,
  getOrganizationItem,
  saveOrganization,
  updateOrganization,
  deleteOrganization,
} from '../../../redux/actions/organization'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getSchemaSidebar } from '../../../redux/actions/sidebar'
import WarningMessage from '../../../components/message/WarningMessage/WarningMessage'

export default function ProjectOrganizationWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleUpdateSave = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError()
    try {
      let response
      if (request.id) {
        console.log('call update.')
        response = await updateOrganization(projectId, request)
      } else {
        console.log('call save.')
        response = await saveOrganization(projectId, request)
      }
      console.log('response', response)

      if (response) {
        setIsError(false)
        setFormSchema(response)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDelete = async (id) => {
    startLoading()
    setIsLoading(true)
    setIsDeleteError(false)
    try {
      console.log('call delete.', id)
      const status = await deleteOrganization(projectId, id)
      if (status === 200) {
        console.log('call get.')
        const response = await getOrganization(projectId)
        console.log('result', response)
        setFormSchema(response)
      } else {
        setIsDeleteError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsDeleteError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('onSubmit data', data)

    const request = {
      id: data.selectedId,
      projectVersionId: projectId,
      organization: data.organization,
      responsibilityRole: data.responsibilityRole,
    }

    console.log('request', request)
    handleUpdateSave(request)
  }

  return (
    <div className="component-overview">
      <Panel
        bordered
        header={formSchema.header}
        eventKey={2}
        shaded
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        <WarningMessage message={formSchema?.feedbackBySubject} />

        {isEdit && showCommandButton ? (
          <ProjectOrganizationForm
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            onSubmit={handleSubmit(onSubmit)}
            onDelete={handleDelete}
            isError={isError}
            isDeleteError={isDeleteError}
            loading={isLoading}
          />
        ) : (
          <div>
            <ProjectOrganizationView schema={formSchema} />
          </div>
        )}

        {showCommandButton && (
          <>
            <hr />
            {!isEdit ? (
              <EditButton
                onClick={() => {
                  onChangeIsEdit(!isEdit)
                  scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
                }}
                disabled={isLoading}
              >
                {`เพิ่ม/แก้ไข ${formSchema.buttonText || formSchema.header}`}
              </EditButton>
            ) : (
              <ViewButton
                icon="backward"
                onClick={() => {
                  onChangeIsEdit(!isEdit)
                  scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
                }}
                disabled={isLoading}
              >
                {`ดูรายการ ${formSchema.buttonText || formSchema.header}`}
              </ViewButton>
            )}
          </>
        )}
      </Panel>
    </div>
  )
}
